import Component_AddingInteractions_08862ef7f908520283b1bf2c56232704 from "../../../../content/guides/adding-interaction-and-color/AddingInteractions";
import Devtool_AddingInteractions_08862ef7f908520283b1bf2c56232704 from "!!@devtool/loader!../../../../content/guides/adding-interaction-and-color/AddingInteractions";
import Component_Colorful_08862ef7f908520283b1bf2c56232704 from "../../../../content/guides/adding-interaction-and-color/Colorful";
import Devtool_Colorful_08862ef7f908520283b1bf2c56232704 from "!!@devtool/loader!../../../../content/guides/adding-interaction-and-color/Colorful";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_AddingInteractions_08862ef7f908520283b1bf2c56232704,
  Devtool_AddingInteractions_08862ef7f908520283b1bf2c56232704,
  Component_Colorful_08862ef7f908520283b1bf2c56232704,
  Devtool_Colorful_08862ef7f908520283b1bf2c56232704,
  DevTool,
  React
};